import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../services/baseQuery';
import {
  type AccessPathParams,
  type GetAccessPathApiResponse,
  type GetHistoryDetailsApiResponse,
  type GetSummaryDetailsApiResponse,
  type GetUserDetailsApiResponse,
  GlobalType,
} from '../types';

export const aagGlobalApi = createApi({
  reducerPath: GlobalType.API_SLICE_NAME,
  baseQuery: axiosBaseQuery({}),
  endpoints: () => ({}),
});

// Extend API with additional endpoints
export const globalApiEndpoints = aagGlobalApi.injectEndpoints({
  endpoints: (builder) => ({
    getPersonalization: builder.query<{ newAAGExperience: boolean }, void>({
      query: () => ({
        url: `/api/idw/personalizations/3`,
        method: 'GET',
        isECMv6: true,
      }),
      transformResponse: (response: { info?: string }) => {
        if (typeof response.info === 'string') {
          try {
            return JSON.parse(response.info) as { newAAGExperience: boolean };
          } catch (e) {
            return { newAAGExperience: true };
          }
        }

        return { newAAGExperience: true };
      },
    }),
    getSummaryDetails: builder.query<unknown, string>({
      query: (sodKey) => ({
        url: `/api/sodms/sod-violations/${sodKey}`,
        isECMv6: true,
      }),
      transformResponse: (response: GetSummaryDetailsApiResponse) => {
        if (response.status === 200) {
          return response.data;
        }

        return {};
      },
    }),
    getUserDetails: builder.query<unknown, string>({
      query: (payload) => ({
        url: `/api/v5/getUser`,
        method: 'POST',
        data: {
          username: payload,
        },
      }),
      transformResponse: (response: GetUserDetailsApiResponse) => {
        if (response.errorCode === '0') {
          return response.userdetails;
        }

        return {};
      },
      transformErrorResponse: (response: { status: number }) => response.status,
    }),
    getHistoryDetails: builder.query<unknown, string>({
      query: (sodKey) => ({
        url: `/api/sodms/sod-violations/${sodKey}/audit-trail`,
        isECMv6: true,
      }),
      transformResponse: (response: GetHistoryDetailsApiResponse) => {
        if (response.status === 200) {
          return response.data;
        }

        return {};
      },
    }),
    getAccessPath: builder.query<unknown, AccessPathParams>({
      query: ({
        violationId,
        assignedEntitlementId,
        violatingEntitlementId,
      }) => ({
        url: `/api/sodms/sod-violations/${violationId}/assigned-entitlement/${assignedEntitlementId}/violating-entitlement/${violatingEntitlementId}/access-path`,
        isECMv6: true,
      }),
      transformResponse: (response: GetAccessPathApiResponse) => {
        if (response.status === 200) {
          return response.data;
        }

        return {};
      },
    }),
  }),
});

export const {
  useLazyGetPersonalizationQuery,
  useLazyGetSummaryDetailsQuery,
  useLazyGetUserDetailsQuery,
  useLazyGetHistoryDetailsQuery,
  useLazyGetAccessPathQuery,
} = globalApiEndpoints;
